/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import React, { useState, useEffect } from 'react';
// @mui
import {
  Container,
  Typography,
  Paper,
  Stepper,
  Step,
  StepLabel,
  Chip,
  InputAdornment,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Check from '@mui/icons-material/Check';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import moment from 'moment';
import { styled } from '@mui/material/styles';
import { getToken } from '../../utils/common';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AddIcon from '@mui/icons-material/Add';
import DialogTitle from '@mui/material/DialogTitle';
import InfoIcon from '@mui/icons-material/Info';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation, useNavigate } from 'react-router-dom';
import data from './dictionary.json';
import { getRole } from '../../utils/common';

// components

// ----------------------------------------------------------------------

export default function AlertDetail(props, { id }) {
  const history = useNavigate();
  const [email, setemail] = React.useState('');
  const [number, setnumber] = React.useState('');
  const [title, settitle] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();

  const [sharedData, setsharedData] = React.useState(location?.state?.index);
  const [objectname, setObjectName] = React.useState('');
  const [note, setnote] = React.useState('');
  const [objectnameafter, setObjectNameafter] = React.useState('');
  const [action, setAction] = React.useState([]);
  const [activestep, setActivestep] = React.useState(0);
  const [peserta, setpeserta] = React.useState(getRole());
  const [decision, setdecisision] = React.useState('');
  const [dis, setdis] = React.useState(true);
  const [alertnote, setalertnote] = React.useState([]);
  const [invalidpath, setInvalidPath] = React.useState('');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filenames, setFilenames] = useState([]);
  const [file, setfile] = useState([]);

  const handleFileUpload = (event, idaction) => {
    const files = event.target.files;

    if (files.length > 0) {
      const newFiles = Array.from(files);

      newFiles.forEach((file) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          const byteArray = new Uint8Array(e.target.result);
          setUploadedFiles((prevFiles) => [
            ...prevFiles,
            { filebyte: byteArray, namafile: file.name, id_action: idaction },
          ]);
          // setFilenames((prevFilenames) => [...prevFilenames, file.name]);
        };

        reader.readAsArrayBuffer(file);
      });
    }
  };
  const uploadFiles = async () => {
    const formData = new FormData();

    uploadedFiles.forEach((fileData) => {
      formData.append('files[]', new Blob([fileData.filebyte]), fileData.namafile, fileData.id_action);
      formData.append('id_action', sharedData?.id);
    });

    try {
      const response = await fetch(window.REACT_APP_API_PURE + 'file/insert', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      if (response.ok) {
        console.log('Files uploaded successfully');
        // Perform any additional actions upon successful upload
      } else {
        console.log('File upload failed');
      }
    } catch (error) {
      console.error('Error uploading files:', error);
    }
  };
  // const handleFileUpload = (event,idaction) => {
  //   const file = event.target.files[0];
  //   // if (file.length > 0) {
  //     setUploadedFiles((prevItems) => [...prevItems, file]);
  //     if (file) {
  //       const reader = new FileReader();

  //       reader.onload = (e) => {
  //         const byteArray = new Uint8Array(e.target.result);
  //         setUploadedFilestoservice((prevItems) => [...prevItems, {filebyte:byteArray,namafile:file.name,id_action:idaction}]);
  //       };

  //       reader.readAsArrayBuffer(file);
  //     }

  //   // }
  //   // console.log(uploadedFiles.length)
  // };
  const fetchInfo2 = (id) => {
    return fetch(window.REACT_APP_API_PURE + `file/list?id=${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        // console.log(d);
        if (d.data[0].file) {
          const binaryData = atob(d.data[0].file);
          const blob = new Blob([new Uint8Array([...binaryData].map((char) => char.charCodeAt(0)))]);
          const url = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.download = d.data[0].nama_file; // Replace with the desired file name and extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
  };

  const handleClick = async (id) => {
    fetchInfo2(id);

    console.info('You clicked the Chip.');
  };

  const insertDataAtIndex = (before, after, setdata, invalid, opp) => {
    const removepath = invalid?.find((val) => val?.operation === opp);
    const parts = removepath?.path?.split('/');
    const convertedArray = parts?.slice(1).map((item) => {
      if (!isNaN(item)) {
        return parseInt(item);
      }
      return item;
    });
    let extractedData = after;
    try {
      for (const key of convertedArray) {
        extractedData = extractedData[key];
      }
    } catch (error) {
      extractedData = null;
    }

    if (extractedData != null) {
      Object.keys(extractedData)?.map((key) => {
        extractedData = { ...extractedData, [key]: '' };
        return;
      });

      if (Array.isArray(before[convertedArray[0]])) {
        const newState = before[convertedArray[0]]?.map((obj, index) => {
          if (index === convertedArray[1] && obj == null) {
            return { ...obj, ...extractedData };
          }

          // 👇️ otherwise return the object as is
          return obj;
        });
        // console.log(newState);
        setdata({ ...before, [convertedArray[0]]: newState });
        // console.log('////////');
        // console.log({ ...before, [convertedArray[0]]: newState });
      }
    }
  };
  const replaceValuesWithEmpty = (obj) => {
    for (const key in obj) {
      if (typeof obj[key] === 'object') {
        replaceValuesWithEmpty(obj[key]);
      } else {
        obj[key] = '';
      }
    }
  };
  useEffect(() => {
    const actiondatanote = sharedData?.action_note == '' ? [] : JSON.parse(JSON.parse(sharedData?.action_note));
    setalertnote(actiondatanote === [] ? [] : actiondatanote || []);

    const invalid = sharedData?.invalid_path_list == '' ? [] : JSON.parse(sharedData?.invalid_path_list);
    setInvalidPath(invalid || []);

    const jsonData = sharedData?.before == '' ? [] : JSON.parse(sharedData?.before);
    setObjectName(jsonData || []);

    const jsonDataAfter = sharedData.after == '' ? [] : JSON.parse(sharedData.after);
    setObjectNameafter(jsonDataAfter || []);

    // console.log(invalid);
    // console.log(jsonData);
    // console.log(jsonDataAfter);
    // console.log(invalid == '' && jsonData == '');
    if (invalid == '' && jsonData == '') {
      const jsonDataAfter2 = sharedData.after == '' ? [] : JSON.parse(sharedData.after);
      setObjectName(jsonDataAfter2 || []);
      // const replacedData = { ...jsonDataAfter2 };
      // replaceValuesWithEmpty(replacedData);
      // setObjectName(replacedData || []);
    }

    // const updatedPeople = invalid.map((data) => {
    //   if (data.path === '/dataHarta/-') {
    //     return { ...data, path: '/dataHarta/8' };
    //   }
    //   return data;
    // });

    ///////////////////

    insertDataAtIndex(jsonData, jsonDataAfter, setObjectName, invalid, 'add');

    insertDataAtIndex(jsonDataAfter, jsonData, setObjectNameafter, invalid, 'remove');

    //////////////////

    const actionJson = sharedData?.action_id == '' ? [] : JSON.parse(sharedData.action_id);
    if (actionJson !== '' || actionJson !== []) {
      actionJson?.map((item, index) => {
        fetch(window.REACT_APP_API_PURE + `action/list?id=${item.id}`, {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        })
          .then((res) => res.json())
          .then((d) => {
            if (d.data !== null) {
              setAction((prevItems) => [...prevItems, { ...d?.data[0], activestep: 0 }]);
            }
          });
      });
    }
    fetch(window.REACT_APP_API_PURE + `file/list?alert_id=${sharedData?.id}`, {
      headers: {
      Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
      setfile(d.data);
      });
  }, []);
  const [expanded, setExpanded] = React.useState(false);
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const checkValueType = (value) => {
    return typeof value;
  };

  const editNote = (itemId, stepId, newNote) => {
    // console.log(itemId);
    // console.log(stepId);
    // console.log(newNote);
    const updatedData = action.map((item) => {
      if (item.id === itemId) {
        const updatedSteps = item.steps.map((step) => {
          if (step.id === stepId) {
            return { ...step, note: newNote };
          }
          return step;
        });
        return { ...item, steps: updatedSteps };
      }
      return item;
    });
    // console.log(updatedData);
    setAction(updatedData);
  };
  const editActiveStep = (itemId, newActiveStep) => {
    const updatedData = action.map((item) => {
      if (item.id === itemId) {
        return { ...item, activestep: newActiveStep };
      }
      return item;
    });
    setAction(updatedData);
    const diss = updatedData?.map((c, i) => {
      if (c.activestep === c.steps.length + 1) {
        return false;
      } else {
        return true;
      }
    });
    setdis(diss.every((v) => v === false));
  };

  const Tittle = ({ tittle = '', subtittle = '', tittle2 = '', subtittle2 = '' }) => {
    return (
      <Grid item container direction={'row'}>
        <Grid item container direction={'row'} xs={4}>
          <Grid item>{tittle} :</Grid>
          <Grid item>{subtittle}</Grid>
        </Grid>
        <Grid item container direction={'row'} xs>
          <Grid item>{tittle2} :</Grid>
          <Grid item>{subtittle2}</Grid>
        </Grid>
      </Grid>
    );
  };
  const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: '#784af4',
    }),
    '& .QontoStepIcon-completedIcon': {
      color: '#784af4',
      zIndex: 1,
      fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
  }));
  const objectJsonGenerator = (objectname, keysebelum, posisi) => {
    return Object.keys(objectname || {})?.map((key, index) => {
      const typevalue = checkValueType(objectname[key]);
      let tittle = capitalizeFirstLetter(key);
      let value = '';
      let keybaru = '/' + keysebelum + '/' + key;

      // console.log(objectname.alamat);
      const errorpath = invalidpath?.find((val) => val.path.split('/-').pop() === keybaru);
      if (typevalue == 'string' || objectname[key] == null) {
        value = objectname[key];
      } else {
        tittle = '';
        //   console.log(objectname[key]);
      }
      return (
        <Grid item container direction={'row'} xs={12}>
          <Grid item xs={12}>
            {Tittle2({
              tittle: tittle,
              subtittle: value,
              operation: errorpath?.operation,
              posisi: posisi,
            })}
          </Grid>
          {typevalue == 'object' && Array.isArray(objectname[key]) ? (
            <Grid item xs={12}>
              <Grid item style={{ paddingTop: 20 }}>
                <Typography variant="h4">{tittle}</Typography>
              </Grid>
              {objectArrayGenerator(objectname[key], keybaru, posisi)}
            </Grid>
          ) : (
            ''
          )}
          {typevalue == 'object' && !Array.isArray(objectname[key]) ? (
            <Grid item xs={12}>
              {objectJsonGenerator(objectname[key], keybaru, posisi)}
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      );
    });
  };
  const objectArrayGenerator = (objectname, keysebelum, posisi) => {
    let indexnotnull = 0;
    let obj = {};
    return objectname?.map((item, index) => {
      let keybaru = '/' + keysebelum + '/' + index;
      const errorpath = invalidpath?.find((val) => val?.path.split('/-').pop() === keybaru);
      if (errorpath != undefined) {
        return Object.keys(item)?.map((key) => {
          const typevalue = checkValueType(item[key]);
          let tittle = capitalizeFirstLetter(key);
          let value = '';
          if (typevalue != 'object' || item[key] == null) {
            value = item[key];
          } else {
            tittle = '';
            //   console.log(objectname[key]);
          }

          return (
            <Grid
              item
              container
              direction={'row'}
              xs={12}
              style={{ backgroundColor: index % 2 === 0 ? 'white' : 'lightgrey', padding: 20 }}
            >
              <Grid item xs={12}>
                {Tittle2({
                  tittle: tittle,
                  subtittle: value || null,
                  operation: errorpath?.operation,
                  posisi: posisi,
                })}
              </Grid>
              {typevalue == 'object' && Array.isArray(item[key]) ? (
                <Grid item xs={12}>
                  <Grid item style={{ paddingTop: 20 }}>
                    <Typography variant="h4">{tittle}</Typography>
                  </Grid>
                  {objectArrayGenerator(item[key], key, posisi)}
                </Grid>
              ) : (
                ''
              )}
              {typevalue == 'object' && !Array.isArray(item[key]) ? (
                <Grid item xs={12}>
                  {objectJsonGenerator(item[key], key, posisi)}
                </Grid>
              ) : (
                ''
              )}
            </Grid>
          );
        });
      }
      if (item !== null) {
        indexnotnull = index;
        obj = objectname[indexnotnull];
      }
      // console.log(item);
      if (item === null) {
        return Object.keys(objectname[indexnotnull])?.map((key) => {
          const typevalue = checkValueType(obj[key]);
          let tittle = capitalizeFirstLetter(key);
          let value = '';
          let keybaru = '/' + keysebelum + '/' + index + '/' + key;

          const errorpath = invalidpath?.find((val) => val?.path.split('/-').pop() === keybaru);

          if (typevalue != 'object' || obj[key] == null) {
            value = '';
          } else {
            tittle = '';
            //   console.log(objectname[key]);
          }
          // console.log(keybaru);
          // console.log(keysebelum);
          // console.log('/' + keysebelum + '/' + index + '/' + key);
          var length = 1;
          if (errorpath?.oldValue?.length >= 40) {
            length = 2;
          }

          return (
            <Grid
              item
              container
              direction={'row'}
              xs={12}
              style={{ backgroundColor: index % 2 === 0 ? 'white' : 'lightgrey', padding: 20 }}
            >
              <Grid item xs={12}>
                {Tittle2({
                  tittle: tittle,
                  subtittle: value || null,
                  operation: errorpath?.operation,
                  length: length,
                  posisi: posisi,
                })}
              </Grid>
              {typevalue == 'object' && Array.isArray(obj[key]) ? (
                <Grid item xs={12}>
                  <Grid item style={{ paddingTop: 20 }}>
                    <Typography variant="h4">{tittle}</Typography>
                  </Grid>
                  {objectArrayGenerator(obj[key], key, posisi)}
                </Grid>
              ) : (
                ''
              )}
              {typevalue == 'object' && !Array.isArray(obj[key]) ? (
                <Grid item xs={12}>
                  {objectJsonGenerator(obj[key], key, posisi)}
                </Grid>
              ) : (
                ''
              )}
            </Grid>
          );
        });
      }
      return Object.keys(item)?.map((key) => {
        const typevalue = checkValueType(item[key]);
        let tittle = capitalizeFirstLetter(key);
        let value = '';
        let keybaru = '/' + keysebelum + '/' + index + '/' + key;

        const errorpath = invalidpath?.find((val) => val?.path.split('/-').pop() === keybaru);

        if (typevalue != 'object' || item[key] == null) {
          value = item[key] || '';
        } else {
          tittle = '';
          //   console.log(objectname[key]);
        }
        // console.log(keybaru);
        // console.log(keysebelum);
        // console.log('/' + keysebelum + '/' + index + '/' + key);
        var length = 1;
        if (errorpath?.oldValue?.length >= 40) {
          length = 2;
        }

        return (
          <Grid
            item
            container
            direction={'row'}
            xs={12}
            style={{ backgroundColor: index % 2 === 0 ? 'white' : 'lightgrey', padding: 20 }}
          >
            <Grid item xs={12}>
              {Tittle2({
                tittle: tittle,
                subtittle: value || null,
                operation: errorpath?.operation,
                length: length,
                posisi: posisi,
              })}
            </Grid>
            {typevalue == 'object' && Array.isArray(item[key]) ? (
              <Grid item xs={12}>
                <Grid item style={{ paddingTop: 20 }}>
                  <Typography variant="h4">{tittle}</Typography>
                </Grid>
                {objectArrayGenerator(item[key], key, posisi)}
              </Grid>
            ) : (
              ''
            )}
            {typevalue == 'object' && !Array.isArray(item[key]) ? (
              <Grid item xs={12}>
                {objectJsonGenerator(item[key], key, posisi)}
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        );
      });
    });
  };

  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#784af4',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#784af4',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));
  function TextAlert(operation) {
    let tittle = '';
    if (operation == 'replace' && sharedData?.name == 'UnAuthorized Data Change') {
      tittle = `(Unauthorized Change Detected)`;
    }
    if (operation == 'replace' && sharedData?.name == 'Authorized Data Change') {
      tittle = `(Authorized Data Change)`;
    }
    if (operation == 'add' && sharedData?.name == 'UnAuthorized Data Change') {
      tittle = `(Unauthorized Change Detected)`;
    }
    if (operation == 'add' && sharedData?.name == 'Authorized Data Change') {
      tittle = `(Authorized Data Change)`;
    }
    if (operation == 'remove' && sharedData?.name == 'UnAuthorized Data Change') {
      tittle = `(Unauthorized Change Detected)`;
    }
    if (operation == 'remove' && sharedData?.name == 'Authorized Data Change') {
      tittle = `(Authorized ${operation} Data Detected)`;
    }
    if (sharedData?.invalid_path_list == '' || sharedData?.before == '') {
      tittle = `(Authorized Data Change)`;
    }
    return `${tittle}`;
  }
  const Tittle2 = ({ tittle = '', subtittle = '', operation = '', length = 1, posisi = 'kanan' }) => {
    if (tittle == 'Nilai') {
      subtittle = parseInt(subtittle, 10);
    }
    let typenumber = checkValueType(subtittle) == 'number';

    let colorednull = sharedData?.invalid_path_list == '' || sharedData?.before == '';

    const labeldata = data?.find((val) => val.label === tittle);

    return tittle == '' ? (
      ''
    ) : (
      <Grid item container direction={'row'} xs={12}>
        <Grid item container direction={'column'} xs={11} spacing={1} style={{ paddingTop: 10 }}>
          <Grid item container direction={'row'} justifyContent={'space-between'}>
            <Grid item>
              {' '}
              <Tooltip title={tittle + ' : ' + labeldata?.description}>
                <span>
                  {' '}
                  <Typography variant="h7">{tittle}</Typography>{' '}
                  <a
                    style={{
                      color: sharedData?.name == 'Authorized Data Change' || colorednull ? 'green' : 'red',
                    }}
                  >
                    {posisi == 'kanan' && (operation != '' || colorednull) ? TextAlert(operation) : ''}
                  </a>
                  <HelpOutlineIcon
                    style={{
                      fontSize: 14,
                      color: subtittle != '-' ? '' : 'transparent',
                    }}
                  />
                </span>
              </Tooltip>
            </Grid>
            {/* <Grid item>
              <Typography
                style={{ color: sharedData?.name == 'Authorized data record update' || colorednull ? 'green' : 'red' }}
                variant="subtitle2"
              >
                {posisi == 'kanan' && (operation != '' || colorednull) ? TextAlert(operation) : ''}
              </Typography>
            </Grid> */}
          </Grid>
          <Grid item>
            <TextField
              size="small"
              id
              fullWidth
              variant="outlined"
              multiline
              rows={length == 1 ? 2 : length}
              value={typenumber ? subtittle.toLocaleString() : subtittle}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
                style: {
                  color: posisi == 'kiri' && invalidpath == '' ? 'transparent' : 'black',
                  backgroundColor: posisi == 'kanan' && (operation != '' || colorednull) ? '#ffeb3b96' : '',
                },
                endAdornment:
                  posisi == 'kanan' && (operation != '' || colorednull) ? (
                    <InputAdornment position="end">
                      <Tooltip title={tittle + ' : ' + labeldata?.description}>
                        <span>
                          {' '}
                          {/* <Typography variant="h7">awdawdwad</Typography> */}
                          <InfoIcon
                            style={{
                              color:
                                sharedData?.name == 'Authorized data record update' || colorednull ? 'green' : 'red',
                            }}
                          />
                        </span>
                      </Tooltip>
                    </InputAdornment>
                  ) : (
                    ''
                  ),
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };
  const url = window.REACT_APP_API_PURE + `alert/list?id=${sharedData?.id}`;

  const fetchInfo = () => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        // console.log(d.data);
        setsharedData(d.data[0]);
      });
  };

  function save(tittle, result) {
    const actionNote = [];
    //  monthNamesArray.push(formattedMonthYear);
    action?.map((item, i) => {
      const data = item.steps?.map((item2, ii) => {
        // console.log(item2);
        return {
          description: item2.description,
          index_note: ii,
          note: item2.note,
          image_url: '',
        };
      });
      let payload = {
        step_name: item.action_name,
        data: data,
      };
      actionNote.push(payload);
    });
    let payload = {
      status: tittle,
      id: sharedData.id,
      result_alert: result,
      action_note: JSON.stringify(actionNote),
    };
    if (sharedData?.status === 'Pending Approval') {
      payload = {
        status: tittle,
        id: sharedData.id,
        result_alert: result,
      };
    }
    fetch(window.REACT_APP_API_PURE + `alert/edit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((d) => {
        if (tittle == 'Pending Approval') {
          history('/dashboard/alert');
        } else {
          fetchInfo();
          history('/dashboard/alert');
        }
      });
  }

  return (
    <>
      <Helmet>
        <title> Information | Smartshield </title>
      </Helmet>

      <Container>
        <Grid container direction={'row'} spacing={5}>
          <Grid item xs={12}>
            <Paper style={{ padding: 20, borderRadius: 10, marginTop: 10 }} elevation={1}>
              <Grid container direction={'column'}>
                <Grid item>
                  <Typography variant="h5">Alert Detail ({sharedData?.id?.split('-').pop()})</Typography>
                </Grid>
                {Tittle({
                  tittle: 'Date',
                  subtittle: moment.unix(sharedData?.created_at).format('YYYY-MM-DD HH:mm'),
                  tittle2: 'Alert',
                  subtittle2: sharedData?.name,
                })}
                {Tittle({
                  tittle: 'Dataset',
                  subtittle: sharedData?.alert_id,
                  tittle2: 'Type',
                  subtittle2: 'Data Integrity', //sharedData?.type,
                })}
                {Tittle({
                  tittle: 'Severity',
                  subtittle: sharedData?.severity,
                  tittle2: 'Status',
                  subtittle2: sharedData?.status,
                })}
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper style={{ padding: 20, borderRadius: 10 }} elevation={1}>
              <Grid container direction={'row'}>
                <Grid item xs={6}>
                  <Typography variant="h4">{t('RecordFromBlockchain.1')}</Typography>
                  {Object.keys(objectname)?.map((key, index) => {
                    const typevalue = checkValueType(objectname[key]);
                    let tittle = capitalizeFirstLetter(key);
                    let tittle2 = capitalizeFirstLetter(key);
                    let value = '';
                    if (typevalue == 'string' || objectname[key] == null) {
                      value = objectname[key];
                    } else {
                      tittle = '';
                      //   console.log(objectname[key]);
                    }
                    const errorpath = invalidpath?.find((val) => val.path.split('/-').pop() === '/' + key);
                    let posisi = 'kiri';
                    let length = 1;
                    if (invalidpath == [] && objectnameafter[key].length >= 40) {
                      length = 2;
                    }
                    return (
                      <Grid item container direction={'row'} xs={12}>
                        <Grid item xs={12}>
                          {Tittle2({
                            tittle: tittle,
                            subtittle: value,
                            operation: errorpath?.operation,
                            posisi: posisi,
                            length: length,
                          })}
                        </Grid>
                        {typevalue == 'object' && Array.isArray(objectname[key]) ? (
                          <Grid item xs={12} container direction={'row'}>
                            <Grid item style={{ paddingTop: 20 }}>
                              <Typography variant="h5">{tittle2}</Typography>
                            </Grid>
                            {objectArrayGenerator(objectname[key], key, posisi)}
                          </Grid>
                        ) : (
                          ''
                        )}
                        {typevalue == 'object' && !Array.isArray(objectname[key]) ? (
                          <Grid item xs={12}>
                            {objectJsonGenerator(objectname[key], key, posisi)}
                          </Grid>
                        ) : (
                          ''
                        )}
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h4">{t('DataVerifResult.1')}</Typography>
                  {Object.keys(objectnameafter)?.map((key) => {
                    const typevalue = checkValueType(objectnameafter[key]);
                    let tittle = capitalizeFirstLetter(key);
                    let tittle2 = capitalizeFirstLetter(key);
                    let value = '';

                    if (typevalue == 'string' || objectname[key] == null) {
                      value = objectnameafter[key];
                    } else {
                      tittle = '';
                      //   console.log(objectname[key]);
                    }
                    const errorpath = invalidpath?.find((val) => val.path.split('/-').pop() === '/' + key);
                    return (
                      <Grid item container direction={'row'} xs={12}>
                        <Grid item xs={12}>
                          {Tittle2({
                            tittle: tittle,
                            subtittle: value,
                            operation: errorpath?.operation,
                            id: key,
                          })}
                        </Grid>
                        {typevalue == 'object' && Array.isArray(objectnameafter[key]) ? (
                          <Grid item xs={12} container direction={'row'}>
                            <Grid item style={{ color: 'transparent', paddingTop: 20 }}>
                              {' '}
                              <Typography variant="h5">{tittle2}</Typography>
                            </Grid>
                            {objectArrayGenerator(objectnameafter[key], key)}
                          </Grid>
                        ) : (
                          ''
                        )}
                        {typevalue == 'object' && !Array.isArray(objectnameafter[key]) ? (
                          <Grid item xs={12}>
                            {objectJsonGenerator(objectnameafter[key], key)}
                          </Grid>
                        ) : (
                          ''
                        )}
                      </Grid>
                    );
                  })}
                </Grid>
                {objectname === '' && objectnameafter === '' ? (
                  <Grid style={{ textAlignLast: 'center' }} xs={12}>
                    Loading... <CircularProgress />{' '}
                  </Grid>
                ) : (
                  ''
                )}
              </Grid>
            </Paper>
          </Grid>

          {peserta == 'Maker' && sharedData?.status === 'Pending Approval'
            ? ''
            : peserta == 'Maker'
            ? action?.map((item, i) => {
                return (
                  <Grid item xs={12}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Grid container direction={'row'}>
                          <Grid item alignSelf={'center'}>
                            <Typography fontWeight={'bold'}>{item.action_name}</Typography>
                          </Grid>
                          <Grid item xs>
                            <Stepper alternativeLabel activeStep={item.activestep} connector={<QontoConnector />}>
                              {item.steps.map((label, i) => (
                                <Step key={label.id}>
                                  <StepLabel StepIconComponent={QontoStepIcon}>
                                    {/* start */}
                                    {i == 0 ? 'Start' : item.steps.length == i + 1 ? 'Finish' : ''}
                                  </StepLabel>
                                </Step>
                              ))}
                            </Stepper>
                          </Grid>
                          <Grid item alignSelf={'center'}>
                            {' '}
                            <span>
                              <Typography
                                variant="subtitle2"
                                // style={{ color: "yellowgreen" }}
                              >
                                Status : {action[i].steps.length == activestep ? 'Complete' : 'In Progress'}
                              </Typography>
                            </span>
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container direction={'column'} spacing={2}>
                          <Grid item container direction={'row'} spacing={2}>
                            <Grid item alignSelf={'center'} xs={12} container direction={'row'}>
                              {item.steps?.map((itemm, i) => (
                                <Chip
                                  label={itemm.description}
                                  color={item.activestep > i ? 'success' : 'primary'}
                                  style={{ marginRight: 20, padding: 5 }}
                                ></Chip>
                              ))}
                            </Grid>

                            {action[i].steps.length == item.activestep ? (
                              <Grid container direction={'row'} style={{ padding: 5, paddingLeft: 20, paddingTop: 20 }}>
                                {item.steps?.map((data, i) => (
                                  <Grid item xs={12}>
                                    <TextField
                                      id="standard-multiline-flexible"
                                      label={'Note  ' + (i + 1)}
                                      multiline
                                      maxRows={4}
                                      disabled
                                      InputProps={{ disableUnderline: true }}
                                      variant="standard"
                                      value={data.note == '' ? '-' : data.note}
                                    />
                                  </Grid>
                                ))}
                              </Grid>
                            ) : (
                              <Grid item xs>
                                {' '}
                                {action[i].steps.length == activestep ? (
                                  ''
                                ) : (
                                  <TextField
                                    fullWidth
                                    placeholder="add note"
                                    label={'note'}
                                    disabled={sharedData?.status == 'Open' ? true : false}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={
                                      item?.steps[
                                        action[i].steps.length == item.activestep
                                          ? item.activestep - 1
                                          : item.activestep
                                      ]?.note
                                    }
                                    onChange={(e) => {
                                      // console.log(action);
                                      editNote(item.id, item?.steps[item.activestep]?.id, e.target.value);
                                    }}
                                  />
                                )}
                              </Grid>
                            )}
                          </Grid>
                          <Grid item>
                            {uploadedFiles.map((file) => {
                              return <Chip label={file.namafile} style={{ marginRight: 10 }}></Chip>;
                            })}
                          </Grid>
                          <Grid item style={{ textAlignLast: 'right' }}>
                            {' '}
                            {action[i].steps.length == item.activestep ? (
                              <Button
                                disabled={sharedData?.status == 'Open' ? true : false}
                                variant="contained"
                                // endIcon={<AddIcon />}
                                style={{
                                  textTransform: 'none',
                                  backgroundColor: 'blue',
                                }}
                                onClick={() => {
                                  const payload = {
                                    index_note: i,
                                    note: note,
                                  };
                                  editActiveStep(item.id, item.activestep - 1);
                                }}
                              >
                                Edit Note
                              </Button>
                            ) : (
                              <Grid container direction={'row'} justifyContent={'space-between'} spacing={2}>
                                <Grid item>
                                  {' '}
                                  <div>
                                    {/* <TextField
        label="Upload Documents"
        variant="outlined"
        disabled
        value={}
      /> */}
                                    <input
                                      type="file"
                                      accept="image/jpeg, image/png, application/pdf"
                                      onChange={(e) => {
                                        handleFileUpload(e, item.id);
                                      }}
                                      multiple
                                      style={{ display: 'none' }}
                                      id="file-input"
                                    />
                                    <label htmlFor="file-input">
                                      <Button component="span" variant="contained" color="primary">
                                        {t('UploadFiles.1')}
                                      </Button>
                                    </label>
                                  </div>
                                </Grid>

                                <Grid item>
                                  {item.activestep == 0 ? (
                                    ''
                                  ) : (
                                    <Button
                                      disabled={sharedData?.status == 'Open' ? true : false}
                                      variant="contained"
                                      // endIcon={<AddIcon />}
                                      style={{
                                        textTransform: 'none',
                                        backgroundColor: 'blue',
                                      }}
                                      onClick={() => {
                                        const payload = {
                                          index_note: i,
                                          note: note,
                                        };
                                        editActiveStep(item.id, item.activestep - 1);
                                      }}
                                    >
                                      Back
                                    </Button>
                                  )}
                                  <Button
                                    disabled={sharedData?.status == 'Open' ? true : false}
                                    variant="contained"
                                    endIcon={<AddIcon />}
                                    style={{
                                      marginLeft: 20,
                                      textTransform: 'none',
                                      backgroundColor: '#679DA0',
                                    }}
                                    onClick={() => {
                                      const payload = {
                                        index_note: i,
                                        note: note,
                                      };
                                      editActiveStep(item.id, item.activestep + 1);
                                    }}
                                  >
                                    Step Completed
                                  </Button>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                );
              })
            : ''}
          {peserta == 'Approval' || (peserta == 'Maker' && sharedData?.status === 'Pending Approval') ? (
            <Grid item xs={12} container direction={'column'}>
              {alertnote !== []
                ? alertnote?.map((item, i) => {
                    return (
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>{item.step_name}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container direction={'column'} spacing={0}>
                            {item.data.map((itemm, ii) => {
                              return (
                                <Grid item>
                                  <Paper
                                    style={{
                                      padding: 10,
                                      backgroundColor: 'lightgray',
                                    }}
                                  >
                                    <Grid container direction={'row'}>
                                      <Grid item xs={6} container direction={'row'}>
                                        {' '}
                                        <Grid item>
                                          <Typography>Description : </Typography>
                                        </Grid>
                                        <Grid item>{' ' + itemm?.description}</Grid>
                                      </Grid>
                                      <Grid item> Note: {itemm?.note || '-'}</Grid>
                                    </Grid>
                                  </Paper>
                                </Grid>
                              );
                            })}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                : action?.map((item, i) => {
                    return (
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography>{item.action_name}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container direction={'column'} spacing={0}>
                            {item.steps.map((itemm, ii) => {
                              return itemm?.description == undefined && itemm?.note == undefined ? (
                                ''
                              ) : (
                                <Grid item>
                                  <Paper
                                    style={{
                                      padding: 10,
                                      backgroundColor: 'lightgray',
                                    }}
                                  >
                                    <Grid container direction={'row'}>
                                      <Grid item xs={6}>
                                        {' '}
                                        <Typography>Description: {itemm?.description}</Typography>
                                      </Grid>
                                      <Grid item> Note: {itemm?.note || '-'}</Grid>
                                    </Grid>
                                  </Paper>
                                </Grid>
                              );
                            })}
                          </Grid>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
              {
                <Grid container direction={'row'} spacing={2} style={{ paddingTop: 20, marginBottom: 100 }}>
                  <Grid item xs={12}>
                    <Typography variant="h6">Document</Typography>
                  </Grid>
                  {file?.map((item, i) => {
                    return (
                      <Grid item xs={4}>
                        {' '}
                        <Chip
                          clickable
                          style={{ backgroundColor: 'rgb(158, 200, 242)' }}
                          onClick={() => {
                            handleClick(item.id);
                          }}
                          label={item.nama_file}
                        ></Chip>
                      </Grid>
                    );
                  })}
                </Grid>
              }
            </Grid>
          ) : (
            ''
          )}
          {peserta != 'Maker' && sharedData?.status != 'Closed' && sharedData?.status != 'Open' ? (
            <Grid
              item
              xs={12}
              textAlign="right"
              container
              direction={'row'}
              spacing={2}
              justifyContent="right"
              style={{ position: 'fixed', bottom: '30px', right: '47px' }}
            >
              <Grid item>
                {' '}
                <Button
                  variant="contained"
                  // endIcon={<AddIcon />}
                  style={{
                    textTransform: 'none',
                    backgroundColor: 'red',
                  }}
                  onClick={() => {
                    save('Process', sharedData?.result_alert);
                  }}
                >
                  Reject
                </Button>
              </Grid>
              <Grid item>
                {' '}
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  style={{
                    textTransform: 'none',
                    backgroundColor: '#679DA0',
                  }}
                  onClick={() => {
                    save('Closed', sharedData?.result_alert);
                  }}
                >
                  Approve {sharedData?.result_alert}
                </Button>
              </Grid>
            </Grid>
          ) : peserta == 'Maker' && sharedData?.status === 'Pending Approval' ? (
            ''
          ) : sharedData?.status != 'Open' && sharedData?.status != 'Closed' ? (
            <Grid
              item
              xs={12}
              textAlign="right"
              container
              direction={'row'}
              justifyContent="right"
              spacing={2}
              style={{ position: 'fixed', bottom: '30px', right: '47px' }}
            >
              <Grid item>
                {' '}
                <Button
                  variant="contained"
                  disabled={dis}
                  // endIcon={<AddIcon />}
                  style={{
                    // color: 'white',
                    textTransform: 'none',
                    backgroundColor: '#679DA0',
                  }}
                  onClick={() => {
                    save('Pending Approval', 'Not Fraud');
                    uploadFiles();
                  }}
                >
                  Not Fraud
                </Button>
              </Grid>
              <Grid item>
                {' '}
                <Button
                  variant="contained"
                  disabled={dis}
                  // endIcon={<AddIcon />}
                  style={{
                    // color: 'white',
                    textTransform: 'none',
                    backgroundColor: 'red',
                  }}
                  onClick={() => {
                    save('Pending Approval', 'Fraud');
                    uploadFiles();
                  }}
                >
                  Fraud
                </Button>
              </Grid>
            </Grid>
          ) : sharedData?.status == 'Closed' ? (
            ''
          ) : peserta != 'Maker' && sharedData?.status == 'Open' ? (
            ''
          ) : (
            <Grid item xs={12} textAlign="right" style={{ position: 'fixed', bottom: '30px', right: '47px' }}>
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                style={{
                  textTransform: 'none',
                  backgroundColor: '#679DA0',
                }}
                onClick={() => {
                  save('Process', '');
                }}
                // onClick={save}
              >
                Process
              </Button>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
  function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? <Check className="QontoStepIcon-completedIcon" /> : <div className="QontoStepIcon-circle" />}
      </QontoStepIconRoot>
    );
  }
}
